module.exports = __webpack_public_path__ + "img/banner03.34b6bea2.jpg";